import "./WelcomeOffer.css";

import type { FC } from "react";

import type { BannerAttributes } from "../banner/TopperWithoutReg";
import useIsMobile from "./useIsMobile";

export type Props = {
  title: string;
  surpriseBonusCard: {
    title: string;
    description: string;
  };
  guaranteed: {
    title?: string;
    cards: Array<{
      title: string;
      subtitle: string;
      detail?: string;
    }>;
  };
  image: BannerAttributes;
  background: BannerAttributes;
};
/**
 * @deprecated
 */
export const WelcomeOffer: FC<Props> = (data) => {
  const isMobile = useIsMobile(700);

  return (
    <div
      className="welcome-offer"
      style={{
        background:
          isMobile && data?.background?.mobileImageVariants
            ? `url(${data?.background.mobileImageVariants}) no-repeat center / cover`
            : `url(${data?.background.imageVariants}) no-repeat center / cover`,
      }}
    >
      <div className=" ">
        <h3 className="welcome-offer-title">{data?.title}</h3>

        <div className="welcome-offer-content">
          <div className="welcome-offer-guaranteed">
            {data?.guaranteed?.title && (
              <h3 className="guarantor-title">{data?.guaranteed?.title}</h3>
            )}

            <div className="guarantor-cards">
              {data?.guaranteed.cards.map((card, index) => (
                <div className="guarantor-card" key={index}>
                  <h4 className="guarantor-card-title">{card.title}</h4>
                  <p className="guarantor-card-subtitle">{card.subtitle}</p>
                  {card?.detail && (
                    <p className="guarantor-card-detail">{card.detail}</p>
                  )}
                </div>
              ))}
            </div>
          </div>

          {data?.image && (
            <div
              className={`welcome-offer-image-wrapper ${
                data?.image?.mobileImageVariants
                  ? "welcome-offer-mobile-image-wrapper"
                  : ""
              }`}
            >
              {data?.image?.imageVariants && (
                <img
                  className="welcome-offer-image"
                  src={data?.image?.imageVariants}
                  alt={data?.image?.imageVariants}
                />
              )}
              {data?.image?.mobileImageVariants && (
                <img
                  className="welcome-offer-image welcome-offer-mobile-image"
                  src={data?.image?.mobileImageVariants}
                  alt={data?.image?.mobileImageVariants}
                />
              )}
            </div>
          )}

          <div className="welcome-offer-guaranteed">
            <div className="guarantor-cards">
              <div className="guarantor-card third">
                <h4 className="guarantor-card-title whitespace-pre-line">
                  {data.surpriseBonusCard.title}
                </h4>
                <p className="guarantor-card-subtitle">
                  {data.surpriseBonusCard.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
